import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { ACTIVITY_TYPES } from "Constants/constants";
import activityTemplates from "src/organization/common/components/activities/activityTemplates";

import { isAutoscaleType } from "./../../../components/Chart/utils";
import * as S from "./style";

const ActivityTooltip = ({ activity }) => {
  const intl = useIntl();
  const [icon, title] = useMemo(() => {
    if (!activity) return [];

    const template =
      activityTemplates[activity.type] || activityTemplates.unknown;

    const showCommitTooltip =
      (activity.type === ACTIVITY_TYPES.ENVIRONMENT.PUSH ||
        activity.type === ACTIVITY_TYPES.ENVIRONMENT.MERGE) &&
      activity.payload.commits;

    const service = activity?.payload?.resources_updated?.webapps
      ? Object.keys(activity.payload.resources_updated.webapps)[0]
      : "your app";

    const showAutoscalingTooltip = isAutoscaleType(
      activity?.payload?.deployment_type
    );

    const autoscalingTitle = intl.formatMessage(
      {
        id: `activity.${activity?.payload?.deployment_type === "autoscale.horizontal.down" ? "downscale" : "upscale"}.title`
      },
      {
        strong: (content: React.ReactNode) => (
          <S.InlineText weight="bold">{content}</S.InlineText>
        ),
        service: <S.InlineText weight="bold">{service}</S.InlineText>
      }
    );
    const title = showCommitTooltip ? (
      <>
        <b>{activity.payload.commits[0].sha.slice(0, 7)}</b>&nbsp;-{" "}
        {activity.payload.commits[0].message}
      </>
    ) : showAutoscalingTooltip ? (
      <S.AutoscaleTitle>{autoscalingTitle}</S.AutoscaleTitle>
    ) : (
      template.title({ activity })
    );

    return [template.icon, title];
  }, [activity, intl]);

  if (!activity) return null;

  return (
    <S.Layout>
      <S.Activity>
        <S.ActivityIcon>{icon}</S.ActivityIcon>
        <S.ActivityTitle>{title}</S.ActivityTitle>
      </S.Activity>
    </S.Layout>
  );
};

ActivityTooltip.propTypes = {
  activity: PropTypes.object.isRequired
};

export default React.memo(ActivityTooltip);
